import { useMutation } from '@tanstack/react-query'

import { usersPasswordResetConfirmPost } from '@src/api'
import { DefaultApiUsersPasswordResetConfirmPostRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useUsersPasswordResetConfirmPost = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiUsersPasswordResetConfirmPostRequest) =>
      usersPasswordResetConfirmPost(axiosInstance, params),
  })
}
